<template>
  <unicom-linha>
    <unicom-coluna sm="auto">
      <div class="segunda-cor-fonte">Total de Prestadores</div>
      <div class="total-prestadores">
        {{ formatarNumero(totalPrestadores) }}
      </div>
    </unicom-coluna>
    <unicom-coluna
      sm="12"
      md="6"
      :class="$breakpoint.smAndDown ? 'mt-3' : ''"
      class="ml-auto"
      alinhamento="center"
    >
      <unicom-barra-pesquisa-complete
        :desativado="loadingGrafico"
        :items="listaUnimed.map(e => e.textoExibicao)"
        v-model="campoPesquisa.descricao"
        @index="selecionarPesquisa"
        @limpar-campos="limparPesquisa"
        placeholder="Buscar por código ou nome da Unimed..."
      />
    </unicom-coluna>
  </unicom-linha>
</template>

<script>
export default {
  props: {
    listaUnimed: {
      type: Array,
      default: () => []
    },
    totalPrestadores: {
      type: Number,
      default: 0
    },
    loadingGrafico: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      campoPesquisa: {
        chave: "",
        descricao: ""
      }
    };
  },
  methods: {
    selecionarPesquisa(index) {
      if ([null, undefined, -1].includes(index)) {
        return;
      }

      const chaveUnimed = this.listaUnimed[index].codigo;
      this.$set(this.campoPesquisa, "chave", chaveUnimed);

      this.$emit("adiciona-filtro", {
        chaveAdicao: "cdUnimed",
        value: chaveUnimed,
        error: () => this.limparCampoPesquisa()
      });
    },
    limparCampoPesquisa() {
      this.campoPesquisa = {
        chave: "",
        descricao: ""
      };
    },
    limparPesquisa() {
      this.$emit("remove-filtro", {
        chaveRemocao: "cdUnimed",
        sucesso: () => this.limparCampoPesquisa()
      });
    },
    formatarNumero(n) {
      return n.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
    }
  },
  watch: {
    ["campoPesquisa.descricao"]() {
      if (this.campoPesquisa.descricao === "") {
        this.$emit("remove-filtro", {
          chaveRemocao: "cdUnimed"
        });
      }
    },
    loading() {
      this.limparCampoPesquisa();
    }
  }
};
</script>

<style lang="scss" scoped>
.total-prestadores {
  font-size: 48px;
  padding-top: 4px;
}
</style>
